// @flow

import React from 'react';
import { Typography, Grid, Container, Tabs, Tab } from '@material-ui/core/';
import TabPanel from '../../components/tabpanel';
import { type ApiCMS } from '../../data/cms/types/api';
import ApiContent from '../../data/cms/content/api';
import Image from '../../components/image';
import Assets from '../../assets';
//import ApiAuthenticationContent from '../../data/cms/content/api-authentication';
//import ApiErrorHandlingContent from '../../data/cms/content/api-errorhandling';
import './style.css';

function GetStarted() {
    const [apiContent, setApiContent] = React.useState<ApiCMS>({});
    const [loading, setLoading] = React.useState(true);
    const [tabIndex, setTabIndex] = React.useState(0);
    /*const [apiAuthContent, setAuthApiContent] = React.useState<ApiAuthCMS>({});
    const [authLoading, setauthLLoading] = React.useState(true);
    const [errContent, setErrApiContent] = React.useState<ApiErrorHandlingCMS>(
        {}
    );
    const [errLoading, setErrLoading] = React.useState(true);*/
    const onTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };
    React.useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    React.useEffect(() => {
        const fetchContent = async () => {
            var fetchedContent = await ApiContent();
            setApiContent(fetchedContent);
            setLoading(false);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        };
        fetchContent();
    }, []);

    return (
        
        <Grid container className="getstart">
            <Container>
           
           
              
                <Grid container className="getstart-body">
                    <Grid item sm={3} md={3} lg={3}>
                        <Typography component="div">
                            <Tabs
                                orientation="vertical"
                                variant="scrollable"
                                value={tabIndex}
                                onChange={onTabChange}
                            >
                                <Tab label="Get Started" />
                                {/*<Tab label="Authentication" />
                                <Tab label="Error Handling" />*/}
                            </Tabs>
                        </Typography>
                    </Grid>
                    <Grid item sm={1} md={1} lg={1}></Grid>
                    <Grid item sm={8} md={8} lg={8} className="getstart-title">
                        <TabPanel value={tabIndex} index={0}>
                            <Typography component="h2">
                                {!loading
                                    ? apiContent.API.GetStarted.Title
                                    : ' '}
                            </Typography>
                            {!loading
                                ? apiContent.API.GetStarted.Steps.Step.map(
                                    (row, index) => {
                                        return (
                                            
                                            <Typography
                                                component="div"
                                                key={index}
                                            >
                                                <Typography component="h3">
                                                    {row.Title}
                                                </Typography>
                                                <Typography
                                                    component="p"
                                                    dangerouslySetInnerHTML={{
                                                        __html: row.Content,
                                                    }}
                                                ></Typography>
                                                {row.IMG != '' ? (
                                                    index ==1?( 
                                                 <Image
                                                 src={Assets.Images.Step1.Path}
                                                 alt={Assets.Images.Step1.Alt}
                                                className="getstart-img"
                                            />):index ==2?( <Image
                                                src={Assets.Images.Step2.Path}
                                             alt={Assets.Images.Step2.Alt}
                                             className="getstart-img"
                                             />):index ==3?( <Image
                                                src={Assets.Images.Step3n.Path}
                                                alt={Assets.Images.Step3n.Alt}
                                                className="getstart-img"
                                            />):index ==4?( <Image
                                                src={Assets.Images.Step4n.Path}
                                                alt={Assets.Images.Step4n.Alt}
                                                className="getstart-img"
                                            />):index ==6?( <Image
                                                src={Assets.Images.Step4.Path}
                                                alt={Assets.Images.Step4.Alt}
                                                className="getstart-img"
                                            />):index ==8?( <Image
                                                src={Assets.Images.Step3.Path}
                                                alt={Assets.Images.Step3.Alt}
                                                className="getstart-img"
                                            />):index ==9?( <Image
                                                src={Assets.Images.Step4.Path}
                                                alt={Assets.Images.Step4.Alt}
                                                className="getstart-img"
                                            />):index ==10?( <Image
                                                src={Assets.Images.Step5.Path}
                                                alt={Assets.Images.Step5.Alt}
                                                className="getstart-img"
                                            />):index ==11?( <Image
                                                src={Assets.Images.Step6.Path}
                                                alt={Assets.Images.Step6.Alt}
                                                className="getstart-img"
                                            />):index ==12?( <Image
                                                src={Assets.Images.Step7.Path}
                                                alt={Assets.Images.Step7.Alt}
                                                className="getstart-img"
                                            />):index ==13?( <Image
                                                src={Assets.Images.Step8.Path}
                                                alt={Assets.Images.Step8.Alt}
                                                className="getstart-img"
                                            />):index ==14?( <Image
                                                src={Assets.Images.Step9.Path}
                                                alt={Assets.Images.Step9.Alt}
                                                className="getstart-img"
                                            />):(<></>)

                                            ):(<> </>)}
                                            </Typography>
                                           
                                           
                                       
                                        );
                                    }
                                )
                                : ' '}
                        </TabPanel>
                        {/*<TabPanel value={tabIndex} index={1}>
                            {!authLoading ? (
                                <Authentication
                                    Content={apiAuthContent.API}
                                    onErrorhandlingClick={
                                        changeTabErrorhandling
                                    }
                                />
                            ) : (
                                ''
                            )}
                        </TabPanel>
                        <TabPanel value={tabIndex} index={2}>
                            {!errLoading ? (
                                <ErrorHandling Content={errContent.API} />
                            ) : (
                                ''
                            )}
                            </TabPanel>*/}
                    </Grid>
                </Grid>
            </Container>
        </Grid>
    );
}

export default GetStarted;